<template>
  <div class="appointmentList-view">
      <div>
        <el-input
            class="w200 mb10 mr10"
            placeholder="请输入单位名称"
            v-model="serchParams.name"
            clearable
        />
        <el-button type="primary" class="myBtn" @click="serchquery">搜索</el-button>
        <el-button type="primary" class="myBtn" @click="reset">重置</el-button>
      </div>
    <el-button @click="add" class="el-button ml10 el-button--primary el-button--small">新增</el-button>

    <commonTable
      :tableData="tableData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="queryParam.pageNum"
      :loading="loading"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column prop="name" align="center" label="单位名称" />
        <el-table-column prop="symbol" align="center" label="单位符号" />
        <el-table-column prop="createBy" align="center" label="创建人"/>
        <el-table-column prop="createTime" align="center" label="创建时间" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="unitEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="delUnit(scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog :visible.sync="addDialogShow" append-to-body :title="title" :close-on-click-modal = false>
       <el-form label-width="100px" :model="formData" :rules="rules" ref="form">
         <el-form-item label="单位名称" prop="name">
             <el-input placeholder="请输入单位名称" v-model="formData.name"></el-input>
         </el-form-item>
         <el-form-item label="单位符号" prop="symbol">
             <el-input placeholder="请输入单位符号" v-model="formData.symbol"></el-input>
         </el-form-item>
       </el-form>
      <div class="flex-c-c">
        <el-button @click="addDialogShow=false">取消</el-button>
        <el-button
            class="save"
            type="primary"
            @click="addConfirm">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable.vue";
import service, {get, post, put, deletes} from "@/utils/request";

import commTable from "@/mixins/commTable";
import {fetchChangeBoss, getWxCodeImg, queryPageEmployee, updateEmployee} from "@/api/companyManage";
import utils from "@/utils";
import {mapGetters} from "vuex";
import {checkPermission} from "@/directives/permission";

export default {
  name: "user",
  mixins: [commTable],
  components: {
    commonTable,
  },
  data() {
    return {
      title: "新增单位",
      queryParam:{
        pageNum:1
      },
      serchParams:{name:''},
      addDialogShow: false,
      formData: {
        name: '',
        symbol: '',
      },
      tableData: [],
      rules: {
        name: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
      },
      roleList: [],
      departmentList: [],
      changeDialogVisible: false,
      allTableData: [],
      newUserId: null,
      userInfo: this.$store.state.loginRoot.userInfo,
    };
  },
  mounted() {
    this.initList('/unit',this.serchParams);
  },
  methods: {
    checkPermission,
    reset(){
      this.serchParams.name=''
      this.queryParam.pageNum = 1
      this.serchquery()
    },
    serchquery(){
      this.queryParam.pageNum = 1
      this.initList('/unit',this.serchParams);
    },
    unitEdit(row){
      this.formData={
        id: row.id,
        name:row.name,
        symbol:row.symbol
        }
        this.title="编辑单位"
        this.addDialogShow=true
    },
    delUnit(row) {
      let params={
        id: row.id
      }
      let that = this
      console.log('row',params)
      deletes('/unit',params).then(res => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        that.initList('/unit',that.serchParams);
      })
    },
    add(){
      this.title='新增单位'
      this.formData.name=''
      this.formData.id=''
      this.formData.symbol=''
      this.addDialogShow=true
    },
    addConfirm(){
      this.$refs.form.validate((valid) => {
         if(valid){
           var method='post'
           // if(this.formData.id){
           //   method='put'
           // }
           service({
             url: '/unit',
             method: method,
             data: this.formData
           }).then(res=>{
             this.addDialogShow=false
             this.$message({
               message: "操作成功",
               type: "success",
             });
             this.initList()
           })
         }
      })

    },
  },
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
.head-img{
  width: 30px;
}
.nickname{
  line-height: 30px;
  vertical-align: top;
  margin-left: 4px;
}
</style>
